import BasicTableClass from './BasicTableClass';
import InverseTableClass from './InverseTableClass';
import HoverableRowsClass from './HoverableRows';
import ContextualClasses from './ContextualClasses';
import TextClass from './TextClass';
import TableClass from './TableClass';
import StripedRowClass from './StripedRowClass';
import StripeInverseClass from './StripInverseClass';
import CaptionClass from './Caption';
import ResponsiveClass from './ResponsiveClass';
import BreckpointClass from './BreckpointClass';
import TableHeadClass from './TableHeadClass';
import InversePrimaryClass from './InversTableClass';
import { Container, Row,  Col, Card, CardHeader, Table } from 'reactstrap';
import React, {  Fragment, useContext } from 'react';
import { StripedRow } from '../../../../Constant';
import { H5 } from '../../../../AbstractElements';
import TableContext from '../../../../_helper/Table';


const BasicTablesContain = () => {
  // const { data } = useContext(TableContext);
  return (
    <Fragment>
      <Container fluid={true}>
        <Row>

          {/* <Col sm="12">
            <Card>
              <CardHeader>
                <H5>{StripedRow} </H5>
                <span>{'No words'}</span>
              </CardHeader>
              <div className="card-block row">
                <Col sm="12" lg="12" xl="12">
                  <div className="table-responsive">
                    <Table striped>
                      <thead>
                        <tr>
                          <th scope="col">{'#'}</th>
                          <th scope="col">{'First Name'}</th>
                          <th scope="col">{'Last Name'}</th>
                          <th scope="col">{'Username'}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          // data.slice(0, 3).map((item) =>
                            <tr key={'1'}>
                              <th scope="row">{'b'}</th>
                              <td>{'c'}</td>
                              <td>{'d'}</td>
                              <td>{'e'}</td>
                            </tr>
                          // )
                        }
                      </tbody>
                      <tbody>
                        {
                          // data.slice(0, 3).map((item) =>
                            <tr key={'2'}>
                              <th scope="row">{'b'}</th>
                              <td>{'c'}</td>
                              <td>{'d'}</td>
                              <td>{'e'}</td>
                            </tr>
                          // )
                        }
                      </tbody>
                    </Table>
                  </div>
                </Col>
              </div>
            </Card>
          </Col> */}

          {/* <BasicTableClass />
            <InverseTableClass />
            <InversePrimaryClass />
            <HoverableRowsClass />
            <ContextualClasses />
            <TextClass />
            <TableClass />
            <TableHeadClass />
            <StripedRowClass />
            <StripeInverseClass />
            <CaptionClass />
            <ResponsiveClass />
            <BreckpointClass /> */}
        </Row>
      </Container>
    </Fragment>
  );
};

export default BasicTablesContain;